<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1350px"
  >
    <template v-slot:activator="{ on }">
      <v-btn  
        icon
        v-on="on"
      >
        <v-icon
          v-if="task.task_status.id===199"
          color="primary"
        >
          mdi-checkbox-marked-circle-outline
        </v-icon>

        <v-icon
          v-else
          color="primary"
        >
          mdi-information-outline
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Task"
      text="Approve Task"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <!-- TASK -->
          <v-col
            cols="7"
            class="pl-5 pr-5"
          >
            <div class="align-header-switch">
              <span class="font-weight-bold header pr-1">
                Task
                <task-dialog-cancel-task
                  :task="task"
                  @updated="emitUpdate"
                />
              </span>
          
              <v-spacer />
              <v-switch
                v-model="approvalTab"
                inset
                class="pt-0 mt-0 margin-auto"
                label="Action Tab"
              />
              <v-avatar
                v-if="task.task_status.id === 199"
                color="red"
                size="7"
                class="mb-5"
              />
            </div>

            <div class="px-4 pr-6 overflow">
              <v-row>
                <div
                  class="task-content content-pre-line"
                  v-html="formatContent(task.content )"
                />
              </v-row>

              <v-row class="mt-2">
                <div class="task-details">
                  <v-row>
                    <v-col
                      cols="6"
                      class="pt-0"
                    >
                      <span class="font-weight-bold"> Task Priority:</span> {{ task.priority.name }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pt-0"
                    >
                      <span class="font-weight-bold"> Task Category:</span> {{ task.task_category.name }}
                    </v-col>
                  </v-row> 
                  <v-row>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <span class="font-weight-bold"> Task Owner:</span> {{ task.owner.person.name }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <span class="font-weight-bold"> Status:</span>
                      <span
                        :class="{ 
                          'warning--text': task.task_status.id === 100,
                          'green--text': task.task_status.id === 199,
                          'black--text': task.task_status.id === 200,
                          'red--text':task.task_status.id === 501
                        }"
                      > {{ task.task_status.name }}</span>
                    </v-col>
                  </v-row> 
                  <v-row>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Created Date:</span> {{ $moment(task.created_at).format('DD MMM YYYY') }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Due Date:</span> {{ $moment(task.due_date).format('DD MMM YYYY') }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Assignee(s):</span> {{ task.assignee_names }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold"> Viewer(s):</span> {{ task.viewer_names }}
                    </v-col>
                  </v-row>
                </div>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  class="font-weight-bold px-0 pb-0"
                >
                  ATTACHMENTS
                  <helper-auto-upload-file-input
                    v-model="file"
                    :max-size-in-mb="2" 
                    :max-number="5"
                    :multiple="true"
                    data-vv-name="files"
                    field-name="files"
                    accept-type=".xlsx,.pdf,.docx,.jpeg,.jpg,.png"
                    extension="ext:xlsx,pdf,docx,jpeg,jpg,png"  
                    @input="uploadDocuments"            
                  >
                    <span 
                      slot="activator"
                      class="mb-2"
                    >   
                      <v-btn                    
                        :disabled="progressing"
                        class="mx-2"    
                        icon
                        color="primary"
                      >
                        <v-icon>
                          mdi-cloud-upload
                        </v-icon>
                      </v-btn>
                    </span>
                  </helper-auto-upload-file-input>
                </v-col>
              
                <v-col
                  cols="12"
                  class="pa-0"
                >
                  <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf, .docx, .xslsx, .jpeg, .jpg, .png only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        :size="15"
                      />
                      <span class="font-weight-bold pl-2">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </v-col>
              </v-row>
              <div class="px-3">
                <v-row>
                  <v-col
                    v-for="document in task.documents"
                    :key="document.id"
                    class="px-0 pb-0"
                    cols="2"
                  >
                    <v-card
                      class="mx-2 mb-2"
                      height="120"
                      width="100"
                      target="_blank"
                      :href="document.file_url"
                    >
                      <div class="file-display">
                        <v-icon
                          v-if="document.file_url.split('.').pop()==='pdf'"
                          color="red"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-pdf'"
                        />

                        <v-icon
                          v-else-if="document.file_url.split('.').pop()==='xlsx'"
                          color="green"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-excel'"
                        />

                        <v-icon
                          v-else-if="document.file_url.split('.').pop()==='docx'"
                          color="blue"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-document'"
                        />

                        <v-img
                          v-else-if="['png','jpeg','jpg'].includes(document.file_url.split('.').pop())"
                          width="80"
                          height="80"
                          :src="document.file_url"
                        />
                      </div>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <p
                            class="text-center font-weight-bold long-and-truncated px-1"
                            v-on="{ ...tooltip }"
                          >
                            {{ document.file_name }}
                          </p> 
                        </template>
                        <span>{{ document.file_name }}</span>
                      </v-tooltip>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>

          <!-- Approval History -->
          <v-col 
            v-show="approvalTab"
            cols="5"
            class="pl-5 pr-5 divider"
          >
            <h4 class="font-weight-bold">
              Approval History
            </h4>

            <div
              v-if="task.approval_request.approvals.length>0" 
              :id="task.approval_scroll_id"
              class="approval-content"
            >
              <v-row
                v-for="approval in task.approval_request.approvals "
                :key="approval.id"
                no-gutters
              >
                <v-col cols="12">
                  <v-list
                    three-line
                    class="py-0"
                  >
                    <v-list-item>
                      <v-list-item-avatar size="55">
                        <v-img :src="approval.approver.thumbnail_url" />
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="body-1">
                          {{ approval.created_by }}
                        </v-list-item-title>

                        <v-list-item-subtitle class="body-2">
                          {{ $moment(approval.created_at).format('D MMMM YYYY') }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle style=" -webkit-line-clamp: unset !important;">
                          Remark: {{ approval.remark }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col> 
              </v-row>
            </div>
            <div
              v-else
              :class="[100].includes(task.task_status.id) ? 'pending-task-no-comment-approval':'no-comment-approval'"
            >
              No Approval History
            </div>

            <div v-if="![100].includes(task.task_status.id)">
              <v-row class="horizontal-divider">
                <v-col cols="11">
                  <v-textarea
                    v-model="remark"
                    v-validate="'required|max:255'"
                    label="Remark"
                    :rows="2"
                    auto-grow
                    outlined
                    class="mt-2"
                    data-vv-name="remark"
                    :error-messages="errors.collect('remark')"
                  />
                </v-col>
               
                <v-col
                  cols="1"
                  class="margin-auto"
                >
                  <v-tooltip
                    v-if="task.task_status.id !== 100"
                    bottom
                  >
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        icon
                        color="success"
                        v-on="{ ...tooltip }"
                        @click="approve"
                      >
                        <v-icon> mdi-check-all</v-icon>
                      </v-btn>
                    </template>
                    <span>Approve Task</span>
                  </v-tooltip>
                  
                  <v-tooltip
                    v-if="task.task_status.id !== 100"
                    bottom
                  >
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        icon
                        color="primary"
                        v-on="{ ...tooltip }"
                        @click="revert"
                      >
                        <v-icon> mdi-redo</v-icon>
                      </v-btn>
                    </template>
                    <span>Revert Task</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
          </v-col>

          <!-- Comments -->
          <v-col 
            v-show="!approvalTab"
            class="pl-5 pr-5 divider"
            cols="5"
          >
            <h4 class="font-weight-bold">
              Comments
            </h4>

            <div
              v-if="task.task_comments.length>0"
              :id="task.comment_scroll_id"
              class="comment-content"
            >
              <v-row
                v-for="comment in task.task_comments "
                :key="comment.id"
                no-gutters
                class="my-2 mx-4"
              >
                <div
                  v-if="task.owner_uid === comment.commentator_uid"
                  class="pa-2 comment-box-left"
                >
                  <v-col
                    cols="12"
                    class="justify-content pa-0 content-pre-line"
                    v-html="formatContent(comment.comment )"
                  />
                  <v-col
                    cols="12"
                    class="align-right pa-0"
                  >
                    <i>
                      {{ $moment(comment.created_at).format('DD MMM YYYY') }} - <span class="font-weight-bold"> {{ comment.employee.person.name }} </span>
                    </i>
                  </v-col>
                </div>
                <div
                  v-else
                  class="pa-2 comment-box-right"
                >
                  <v-col
                    cols="12"
                    class="justify-content pa-0 content-pre-line" 
                    v-html="formatContent(comment.comment )"
                  />
                  <v-col
                    cols="12"
                    class="align-left pa-0"
                  >
                    <i>
                      <span class="font-weight-bold"> {{ comment.employee.person.name }} </span> - {{ $moment(comment.created_at).format('DD MMM YYYY') }} 
                    </i>
                  </v-col>
                </div>
              </v-row>
            </div>
            <div
              v-else
              class="no-comment-approval"
            >
              No Comments
            </div>

            <div>
              <v-row class="horizontal-divider">
                <v-col cols="11">
                  <v-textarea
                    v-model="comment"
                    v-validate="'required|max:255'"
                    :disabled="sent"
                    label="Comment"
                    :rows="2"
                    auto-grow
                    :loading="commentLoading"
                    outlined
                    class="mt-2"
                    data-vv-name="comment"
                    :error-messages="errors.collect('comment')"
                  />
                </v-col>
            
                <v-col
                  cols="1"
                  class="margin-auto"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        icon
                        color="info"
                        :disabled="sent"
                        @click="submitComments"
                        v-on="{ ...tooltip }"
                      >
                        <v-icon>mdi-send</v-icon>
                      </v-btn>
                    </template>
                    <span>Send</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperAutoUploadFileInput: () => import('@/components/helper/AutoUploadFileInput'),
      TaskDialogCancelTask: () => import('@/components/task/DialogCancelTask'),
    },

    inject: ['$validator'],
    props: {
      task: {
        type: Object,
        default: null,
      },

    },
    data () {
      return {
        dialog: false,
        progressing: false,
        remark: null,
        approvalTab: false,
        file: null,
        comment: null,
        sent: false,
        commentLoading: false,
      }
    },

    watch: {
      approvalTab (value) {
        if (value && this.dialog) {
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      },

      task (value) {
        if (this.dialog) {
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      },
      
      dialog (value) {
        if (value) {
          this.$nextTick(() => {
            this.scrollBottom()
          })
        } else {
          this.resetForm()
        }
      },
    },

    methods: {
      scrollBottom () {
        // comment section
        if (this.task.task_comments.length > 0) {
          let comment = document.getElementById(this.task.comment_scroll_id)
          comment.scrollTop = comment.scrollHeight
        }

        // approval history
        if (this.task.approval_request.approvals.length > 0) {
          let approval = document.getElementById(this.task.approval_scroll_id)
          approval.scrollTop = approval.scrollHeight
        }
      },

      emitUpdate () {
        this.$emit('updated')
      },

      formatContent (content) {
        if (content.includes('http')) {
          let urlRegex = /(https?:\/\/[^\s]+)/g
          return content.replace(urlRegex, function (url) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>'
          })  
        }
     
        return content
      },

      prepareDocumentFormData () {
        if (this.file) {
          return this.file.formData
        }

        let formData = new FormData()

        return formData
      },

      uploadDocuments () {
        if (this.file) {
          this.$api.taskDocuments().create(this.task.id, this.prepareDocumentFormData())
            .then((res) => {
              this.$snack({ message: 'Document(s) uploaded succesfully' })
              this.$emit('updated')
              this.file = null
            }).catch(e => {
              this.file = null
            })
        }
      },

      prepareCommentData () {
        return {
          comment: this.comment,
        }
      },

      submitComments () {
        this.sent = true
        this.commentLoading = true

        this.$validator.validate('comment', this.comment)
          .then(result => {
            if (!result) return false

            this.sent = true
            this.commentLoading = true

            this.$api.taskComments().create(this.task.id, this.prepareCommentData())
              .then((res) => {
                this.resetComment()
                this.$emit('updated')
                this.sent = false
                this.commentLoading = false
              })
          })
      },

      approve () {
        this.$validator.validate('remark', this.remark)
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.ownerTasks().approve(this.task.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')             
                  this.$snack({ message: response.data.message })
                  this.dialog = false    
                }
              }).catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to approve task', 
                })
              }).then(() => {
                this.progressing = false
              })
          })
      },

      revert () {
        this.$validator.validate('remark', this.remark)
          .then(result => {
            if (!result) return

            this.$api.ownerTasks().revert(this.task.id, this.prepareFormData())
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.message })

                this.dialog = false
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to revert task', 
                }) 
              })
              .then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          remark: this.remark,
        }
      },

      resetForm () {
        this.$validator.reset()
        this.remark = null
        this.approvalTab = false
      },

      resetComment () {
        this.$validator.reset()
        this.comment = null
      },
    },
  }
</script>

<style scoped>
.task-details{
  background-color:#fbfbfb;
  border-radius:5px;
  padding:10px;
  width:100%
}

.task-content{
  border:1px solid #e6e6e6;
  border-radius:5px;
  padding:10px;
  min-height:100px;
  width:100%;
  text-align: justify;
  text-justify: inter-word;
  font-size:15px;
  color:#343434
}

.margin-auto{
  margin:auto
}

.file-display{
  min-height:70px;
  text-align:center;
  display:flex
}

.long-and-truncated {
  display: inline;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;/* Important for long words! */
}

.divider{
  border-left:1px solid #e6e6e6
}

.horizontal-divider{
  border-top:1px solid #e6e6e6;
  margin-top:20px
}

.header{
  font-size:18px !important
}

.align-header-switch{
  display: flex;
  margin-top: 12px;
  height: 40px;
}

.approval-content{
  max-height:360px;
  overflow-y:auto;
  min-height:360px
}

.comment-content{
  max-height:360px;
  overflow-y:auto;
  min-height:360px
}

.comment-box-left{
  border:1px solid #e6e6e6;
  border-radius:5px;
  width:436px;
  margin-left:30px;
}

.comment-box-right{
  border:1px solid #e6e6e6;
  border-radius:5px;
  width:436px;
  margin-right:30px;
}

.justify-content{
  text-align: justify;
  text-justify: inter-word;
}

.align-right{
  text-align:right
}

.overflow{
  height:500px;
  overflow-y:auto;
}

::-webkit-scrollbar {
  width: 3px;
}

.no-comment-approval{
  max-height:360px;
  overflow-y:auto;
  min-height:360px
}

.pending-task-no-comment-approval{
  max-height:505px;
  overflow-y:auto;
  min-height:505px
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.content-pre-line{
  white-space: pre-line
}
</style>
